/* LAYOUT */
export const TEAMS_ORGS = "TEAMS_ORGS"
export const TEAMS_ORGS_ERROR = "TEAMS_ORGS_ERROR"
export const MONTHLY_LOGS = "MONTHLY_LOGS"
export const MONTHLY_LOGS_LOADING = "MONTHLY_LOGS_LOADING"
export const MONTHLY_LOGS_ERROR = "MONTHLY_LOGS_ERROR"


